<template>
  <v-container fluid class="saleschannel-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Channel</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="left">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Channel</p>
                        <v-text-field
                          class="mb-4"
                          v-model="new_saleschannel.channelcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Channel Code"
                          persistent-hint
                          single-line hint="Enter the channel code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_saleschannel.channelname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Channel Name"
                          persistent-hint
                          single-line hint="Enter the channel name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_saleschannel.channelinfo"
                          outlined
                          dense
                          placeholder="Channel Info"
                          persistent-hint
                          single-line hint="Enter the channel info">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items="['Channel', 'Other Channel']"
                          v-model="new_saleschannel.channeltype"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the channel type">
                        </v-select>

                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md=12>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/saleschannel/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertSalesChannel()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      new_saleschannel: {},
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('SalesChannel', ['insertSalesChannelRequest','getSalesChannelsRequest']),
    checkError(){
      if(!this.new_saleschannel.channelcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_saleschannel.channelname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_saleschannel.channeltype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertSalesChannel() {
      await this.insertSalesChannelRequest(this.new_saleschannel)
      router.push('/saleschannel/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.channel.channelimage = file;
      this.channel.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('SalesChannel', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
